import { Input, InputLeftAddon, InputProps, InputRightAddon } from "../Forms";
import { IconButton } from "../Buttons";
import { MagnifyingGlassIcon, XMarkIcon } from "@heroicons/react/24/solid";
import { InputGroup } from "../Forms/Input/InputGroup";
import { ChangeEvent, useRef, useState } from "react";
import { Nil } from "cy-util";
import { cn } from "../../utils/cn";

export interface SearchInputProps {
  onSearch: (value: string | Nil) => void;
  className?: string;
  inputProps?: InputProps;
}

const styles = "";
export function SearchInput({
  className,
  onSearch,
  inputProps,
}: SearchInputProps) {
  const css = cn(className, styles);
  const { onChange, value, ...restInputProps } = inputProps || {};
  const [_value, setValue] = useState<string>("");
  const ref = useRef<HTMLInputElement>(null);
  function search() {
    onSearch && onSearch(ref.current?.value.toLowerCase().trim());
  }

  function _onChange(event: ChangeEvent<HTMLInputElement>) {
    if (value == null) {
      setValue(event.target.value);
    }
    onChange && onChange(event);
  }
  function _onClear() {
    onSearch && onSearch("");
    if (value == null) {
      setValue("");
    }
  }
  if (value && _value) {
    console.warn(
      "You are trying to mix controlled and uncontrolled input.Dont do it.",
    );
  }
  // use internal value if prop value is null
  const realValue = value == null ? _value : value;
  return (
    <InputGroup className={css}>
      <InputLeftAddon>
        <IconButton onClick={search} vRounded className="h-9 w-9 p-2">
          <MagnifyingGlassIcon />
        </IconButton>
      </InputLeftAddon>
      <Input
        ref={ref}
        value={realValue}
        onChange={_onChange}
        onEnterPress={search}
        {...restInputProps}
      />

      {!!realValue && (
        <InputRightAddon>
          <IconButton onClick={_onClear} vRounded className="h-9 w-9 p-2">
            <XMarkIcon />
          </IconButton>
        </InputRightAddon>
      )}
    </InputGroup>
  );
}
